var React = require('react');

function Be (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"a","key":0},React.createElement("circle",{"cx":"256","cy":"256","r":"256","fill":"#fff"})),React.createElement("g",{"mask":"url(#a)","key":1},[React.createElement("path",{"fill":"#333","d":"M0 0h167l38.2 252.6L167 512H0z","key":0}),React.createElement("path",{"fill":"#d80027","d":"M345 0h167v512H345l-36.7-256z","key":1}),React.createElement("path",{"fill":"#ffda44","d":"M167 0h178v512H167z","key":2})])]);
}

Be.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Be;

Be.default = Be;
